import { CommonModule } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import {
  MAT_DIALOG_DATA,
  MatDialogActions,
  MatDialogContent,
  MatDialogRef,
  MatDialogTitle
} from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';

export interface GocCollaborationRestrictionDialogData {
  title: string;
  message: string;
}

@Component({
  selector: 'app-goc-collaboration-restriction-dialog',
  templateUrl: './goc-collaboration-restriction-dialog.component.html',
  styleUrls: ['./goc-collaboration-restriction-dialog.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    MatButtonModule,
    MatDialogActions,
    MatDialogTitle,
    MatDialogContent
  ]
})
export class GocCollaborationRestrictionDialogComponent {
  readonly okButtonLabel: string;

  constructor(
    private readonly dialogRef: MatDialogRef<GocCollaborationRestrictionDialogComponent>,
    private readonly translateService: TranslateService,
    @Inject(MAT_DIALOG_DATA) public data: GocCollaborationRestrictionDialogData
  ) {
    this.okButtonLabel = this.translateService.instant('OK_BTN');
  }

  onConfirmClick(): void {
    this.dialogRef.close(true);
  }
}
